import styled from 'styled-components';
import { FLUENT_UI_EMOJIS } from '../../../../../../../../../assets';

export const Icon = styled(FLUENT_UI_EMOJIS.HIGH_VOLTAGE)``;
